import { Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d09c11f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "user item"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Reference", -1))
const _hoisted_3 = { class: "value" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Name", -1))
const _hoisted_5 = { class: "value" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, "About", -1))
const _hoisted_7 = { class: "value" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Joined", -1))
const _hoisted_9 = { class: "value" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Reference", -1))
const _hoisted_11 = { class: "value" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Title", -1))
const _hoisted_13 = { class: "value" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Photo", -1))
const _hoisted_15 = { class: "value" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { key: 3 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Reference", -1))
const _hoisted_19 = { class: "value" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Title", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Description", -1))
const _hoisted_23 = { class: "value" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Reference", -1))
const _hoisted_25 = { class: "value" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Date", -1))
const _hoisted_27 = { class: "value" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, "When", -1))
const _hoisted_29 = { class: "value" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, "View", -1))
const _hoisted_31 = { class: "value" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("View Calendar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoTask = _resolveComponent("InfoTask")!
  const _component_router_link = _resolveComponent("router-link")!

  return (!_ctx.str || !_ctx.str.link)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
    : (_ctx.isUser(_ctx.str.link.type))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.str.content), 1),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.getUser(_ctx.str).name), 1),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.getUser(_ctx.str).about), 1),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.dtFormat(_ctx.getUser(_ctx.str).created)), 1)
        ]))
      : (_ctx.isPhoto(_ctx.str.link.type))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.str.content), 1),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.getPhoto(_ctx.str).alt), 1),
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("img", {
                src: _ctx.getPhoto(_ctx.str).href,
                alt: _ctx.getPhoto(_ctx.str).alt,
                class: "popup-img"
              }, null, 8, _hoisted_16)
            ])
          ], 64))
        : (_ctx.isTask(_ctx.str.link.type))
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_InfoTask, {
                item: _ctx.getTask(_ctx.str),
                highlight: _ctx.highlight,
                onItemClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doSubItemClick($event))),
                showRefsInline: false
              }, null, 8, ["item", "highlight"])
            ]))
          : (_ctx.isCenter(_ctx.str.link.type))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.str.content), 1),
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.getCenter(_ctx.str).title), 1),
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.getCenter(_ctx.str).description), 1)
              ], 64))
            : (_ctx.isDate(_ctx.str.link.type))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.str.content), 1),
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.getLongDate(_ctx.str)), 1),
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.getDuration(_ctx.str)), 1),
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_router_link, {
                      to: `/cal/${_ctx.str.link.href}`
                    }, {
                      default: _withCtx(() => [
                        _hoisted_32
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ], 64))
              : _createCommentVNode("", true)
}